import {config} from "./config/config.js";
import {GameObjectType, type TLevelObject} from "./config/types.js";
import type {WipLevelEntityV2} from "./typesV2.js";

export const createDefaultWipLevelEntityV2 = (
  creatorId: string,
  name: string,
): WipLevelEntityV2 => ({
  creatorId,
  name,
  data: createDefaultLevelEntityV2(),
  createdAt: new Date(),
  updatedAt: new Date(),
});

export const createDefaultLevelEntityV2 = (): TLevelObject[] => [
  {
    type: GameObjectType.SPAWN,
    scale: config.objectTypes[GameObjectType.SPAWN].defaultScale,
    position: [0, 0],
    rotation: 0,
  },
  {
    type: GameObjectType.SHARD,
    scale: config.objectTypes[GameObjectType.SHARD].defaultScale,
    position: [0, 5],
    rotation: 0,
  },
];
